import React from 'react';
import _ from 'underscore';

export interface IHelpRailViewIdProps {
  railViewId: string;
}

export class HelpRailViewId extends React.PureComponent<IHelpRailViewIdProps> {
  componentDidMount() {
    if (window.ApexPlatform && _.isFunction(window.ApexPlatform.Refresh)) {
      window.ApexPlatform.Refresh();
    }
  }

  render() {
    return (
      <div
        railviewid={this.props.railViewId}
        style={{ display: 'none' }}
      />
    );
  }
}
